import { BaseDto } from '@/shared/dtos/base-dto';

export class calendario_laboral_dia extends BaseDto {
    public fecha!:Date;
    public id_tipo_fichaje !: number;
    public id_calendario_laboral !: number;
 } 
